// Snelfilters voor de handelskansen-pagina. Elk filter is een pure test op één rij.
export const QUICK_FILTERS = [
  { key: "score80", label: "Score > 80", test: (r) => (r.headline?.deal_score ?? 0) > 80 },
  { key: "margin10", label: "Marge > € 10k", test: (r) => (r.headline?.contribution ?? 0) > 10000 },
  { key: "margin20", label: "Marge > € 20k", test: (r) => (r.headline?.contribution ?? 0) > 20000 },
  { key: "roi10", label: "ROI > 10%", test: (r) => (r.headline?.roi_pct ?? 0) > 10 },
  { key: "vat", label: "BTW aftrekbaar", test: (r) => r.vehicle_snapshot?.vat_status === "BTW aftrekbaar" },
  { key: "dealer", label: "Dealer", test: (r) => r.vehicle_snapshot?.seller_type === "Dealer" },
  { key: "private", label: "Particulier", test: (r) => r.vehicle_snapshot?.seller_type === "Particulier" },
  { key: "lowbpm", label: "Lage BPM", test: (r) => (r.headline?.bpm ?? Infinity) < 8000 },
  { key: "highconf", label: "Hoge betrouwbaarheid", test: (r) => (r.headline?.confidence_pct ?? 0) >= 75 },
  { key: "de", label: "Duitsland", test: (r) => r.vehicle_snapshot?.country === "DE" },
  { key: "nl", label: "Nederland", test: (r) => r.vehicle_snapshot?.country === "NL" },
  { key: "saved", label: "Opgeslagen", test: (r) => r.saved },
  {
    key: "norisk",
    label: "Zonder HOOG risico",
    test: (r) => (r.red_flags?.counts?.high || 0) === 0,
  },
  {
    key: "onlyrisk",
    label: "Alleen HOOG risico",
    test: (r) => (r.red_flags?.counts?.high || 0) > 0,
  },
];
